import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  Form,
  InputGroup,
  InputGroupText,
  Table,
  Badge,
} from "reactstrap";
import styles from "./Contacts.module.scss";
import avatarHombre from "../../assets/images/avatarHombre.jpg";
import avatarMujer from "../../assets/images/avatarMujer.jpg";
import companyAvatar from "../../assets/images/companyAvatar.jpg";
import imgDefault from "../../assets/images/avatar-verde2.png";
import { connect, useDispatch, useSelector } from "react-redux";
import { withRouter, Link, useHistory } from "react-router-dom";
import Pagination from "../../components/Common/Pagination";
import Loader from "../../components/Common/Loader";
import { contactsList } from "../../store/contacts/actions";
import { contactsFilter } from "../../store/contacts/actions";
import SweetAlert from "react-bootstrap-sweetalert";
import {
  getCampaignFullList,
  getContactsOfCampaign,
  postContactsOfCampaign,
  postContactsUpload,
} from "../../helpers/backend";
import { 
  TbLayoutList, 
  TbLayoutGrid, 
  TbEdit, 
  TbSearch,
  TbPlus,
  TbDownload,
  TbUpload,
  TbMapPin,
  TbBuilding,
  TbUser,
  TbId,
  TbPlug,
  TbUserCheck
} from "react-icons/tb";
import axios from "axios";
import ButtonVolver from "../../components/ButtonVolver";

// Componente reutilizable para SweetAlert
const Alert = ({ title, message, type, onConfirm }) => {
  return (
    <SweetAlert
      title={title}
      onConfirm={onConfirm}
      type={type}
      timeout={2000}
      showConfirm={false}
    >
      {message}
    </SweetAlert>
  );
};

const ContactsList = (props) => {
  const URL = process.env.REACT_APP_API_URL;
  const dispatch = useDispatch();
  const history = useHistory();
  const user = JSON.parse(localStorage.getItem("user"));
  const groups = String(user.groups);

  const [search, setSearch] = useState("");
  const [active, setActive] = useState(true);
  const [contactOpen, setContactOpen] = useState(false);
  const [campaignAssign, setCampaignAssign] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const [dropdownOpenChat, setDropdownOpenChat] = useState(false);
  const [activeIndexChat, setActiveIndexChat] = useState(null);
  const [dropdownOpenTel, setDropdownOpenTel] = useState(false);
  const [activeIndexTel, setActiveIndexTel] = useState(null);
  const [campaignId, setCampaignId] = useState(null);
  const [campaign, setCampaign] = useState("");
  const [contactId, setContactId] = useState(null);
  const [groupAssign, setGroupAssign] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  // Estados para manejar alertas reutilizables
  const [alert, setAlert] = useState(null);

  const theme = useSelector((state) => state.theme.theme) || "light";

  const [campaignData, setCampaignData] = useState([]);
  const [contactsOfCampaign, setContactsOfCampaign] = useState([]);

  // Función para mostrar una alerta de éxito
  const showSuccessAlert = (message) => {
    setAlert({
      title: "Hecho!",
      message: message,
      type: "success",
    });
  };

  // Función para mostrar una alerta de error
  const showErrorAlert = (message) => {
    setAlert({
      title: "Lo sentimos!",
      message: message,
      type: "error",
    });
  };

  // Función para cerrar la alerta
  const closeAlert = () => {
    setAlert(null);
  };

  // Función para manejar errores de peticiones
  const handleError = (error) => {
    console.log(error);
    if (error && error.status === 400) {
      showErrorAlert(error.detail || "Error en la solicitud.");
    } else {
      showErrorAlert("Ocurrió un error inesperado.");
    }
  };

  // Obtener datos de campañas
  const getCampaignData = async () => {
    try {
      const response = await getCampaignFullList();
      const data = response.data;
      setCampaignData(data);
    } catch (error) {
      handleError(error);
    }
  };

  // Obtener contactos de una campaña
  const getContactsData = async () => {
    try {
      const response = await getContactsOfCampaign(campaign);
      const data = response.data;
      setContactsOfCampaign(data);
    } catch (error) {
      handleError(error);
    }
  };

  // Cambiar estado del dropdown
  const toggleDropdown = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const toggleDropdownChat = (index) => {
    setActiveIndexChat(activeIndexChat === index ? null : index);
  };

  const toggleDropdownTel = (index) => {
    setActiveIndexTel(activeIndexTel === index ? null : index);
  };

  // Manejar cambios en el buscador
  const onChange = (e) => {
    setSearch(e.target.value);
  };

  // Enviar búsqueda
  const onSubmit = (e) => {
    e.preventDefault();
    dispatch(contactsFilter(`?search=${search}`));
  };

  // Efecto para cargar datos de campañas y contactos
  useEffect(() => {
    dispatch(contactsList());
    getCampaignData();
  }, [dispatch]);

  useEffect(() => {
    if (campaign) {
      getContactsData();
    }
  }, [campaign]);

  // Navegar al perfil del contacto
  const handleShow = (id) => {
    history.push(`/contact/${id}/contact_profile`);
  };

  // Importar archivo Excel
  const postExcel = async () => {
    if (!selectedFile) {
      showErrorAlert("Por favor, selecciona un archivo.");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);
    setLoading(true);
    try {
      const response = await postContactsUpload(formData);
      if (response.status === 200) {
        setLoading(false);
        showSuccessAlert("Archivo importado correctamente.");
      }
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  // Exportar archivo Excel
  const handleExport = async () => {
    try {
      const url = `${URL}/contact/contacto/exportar-excel/`;
      const response = await axios.get(url, { responseType: "blob" });
      if (response && response.data) {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const urlBlob = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = urlBlob;
        link.setAttribute("download", "Contactos.xlsx");
        document.body.appendChild(link);
        link.click();

        // Limpiar el URL del blob
        window.URL.revokeObjectURL(urlBlob);
        document.body.removeChild(link);
      } else {
        console.error("No se recibieron datos para exportar.");
      }
    } catch (error) {
      console.error("Error al exportar el archivo:", error);
    }
  };

  // Parámetros para la paginación
  const params = {
    count: props.contacts.count,
    next: props.contacts.next,
    previous: props.contacts.previous,
    results: props.contacts.results,
  };

  // Preparar datos para la tabla
  const tableData = Array.isArray(params.results)
    ? params.results.map((contact, idx) => ({
        ...contact,
        direccion: contact.address && contact.address.length > 0 ? contact.address[0].address : "N/A",
        ciudad: contact.address && contact.address.length > 0 
          ? `${contact.address[0].city || ''}${contact.address[0].city && contact.address[0].state ? ', ' : ''}${contact.address[0].state || ''}`
          : "N/A",
      }))
    : [];

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Ciudad Limpia | Contactos</title>
        </MetaTags>
        <Container fluid>
          {/* Header */}
          <Row className="mb-4">
            <Col>
              <div className="d-flex align-items-center gap-3">
                <ButtonVolver />
                <div>
                  <h4 className="mb-0 fw-semibold">Contactos</h4>
                  <p className="text-muted mb-0">
                    {params.count} contactos encontrados
                  </p>
                </div>
              </div>
            </Col>
          </Row>

          {/* Barra de Búsqueda y Acciones */}
          <Row className="mb-4 align-items-center">
            <Col lg={6} md={8}>
              <Form onSubmit={onSubmit}>
                <InputGroup>
                  <InputGroupText className="bg-light border-end-0">
                    <TbSearch size={18} className="text-muted" />
                  </InputGroupText>
                  <input
                    type="text"
                    className="form-control border-start-0"
                    placeholder="Buscar contactos..."
                    value={search}
                    onChange={onChange}
                  />
                </InputGroup>
              </Form>
            </Col>
            
            <Col lg={6} md={4}>
              <div className="d-flex gap-2 justify-content-md-end align-items-center flex-wrap">

                
                <div className="btn-group ms-2">
                  <button
                    className={`btn btn-outline-success ${active ? "active" : ""}`}
                    onClick={() => setActive(true)}
                  >
                    <TbLayoutGrid size={18} />
                  </button>
                  <button
                    className={`btn btn-outline-success ${!active ? "active" : ""}`}
                    onClick={() => setActive(false)}
                  >
                    <TbLayoutList size={18} />
                  </button>
                </div>
              </div>
            </Col>
          </Row>

          {props.loading || loading ? (
            <Loader />
          ) : (
            <div>
              {params.count !== 0 ? (
                <CardBody className="p-0">
                  {active ? (
                    // Vista en Tarjetas Compactas Elegantes
                    <div className={styles["compact-elegant-container"]}>
                      {params.results &&
                        params.results.map((contact, idx) => (
                          <div 
                            key={idx} 
                            className={styles["compact-elegant-card"]}
                            onClick={() => handleShow(contact.id)}
                          >
                            <div className={styles["card-main"]}>
                              <div className={styles.avatar}>
                                {contact.image ? (
                                  <img src={contact.image} alt="" />
                                ) : contact.contactType && contact.gender === "Masculino" ? (
                                  <img src={avatarHombre} alt="" />
                                ) : contact.contactType && contact.gender === "Femenino" ? (
                                  <img src={avatarMujer} alt="" />
                                ) : contact.contactType === "EMPRESA" ? (
                                  <img src={companyAvatar} alt="" />
                                ) : (
                                  <img src={imgDefault} alt="" />
                                )}
                              </div>
                              <div className={styles.content}>
                                <div className={styles.header}>
                                  <h6 className={styles.name}>
                                    {contact.get_full_name}
                                  </h6>
                                </div>
                                
                                <div className={styles.details}>
                                  <div className={`${styles.detail} ${styles.contrato}`}>
                                    <TbId size={14} />
                                    <span className={styles.label}>Contrato:</span>
                                    <span className={styles.value}>{contact.cuenta_contrato_ciudad_limpia || "N/A"}</span>
                                  </div>
                                  
                                  <div className={`${styles.detail} ${styles.enel}`}>
                                    <TbPlug size={14} />
                                    <span className={styles.label}>Enel:</span>
                                    <span className={styles.value}>{contact.cuenta_enel || "N/A"}</span>
                                  </div>
                                  
                                  <div className={`${styles.detail} ${styles.suscriptor}`}>
                                    <TbUserCheck size={14} />
                                    <span className={styles.label}>Suscriptor:</span>
                                    <span className={styles.value}>{contact.suscriptor || "N/A"}</span>
                                  </div>

                                  {contact.address && contact.address.length > 0 && (
                                    <div className={`${styles.detail} ${styles.direccion}`}>
                                      <TbMapPin size={14} />
                                      <span className={styles.label}>Dirección:</span>
                                      <span className={styles.value}>
                                        {contact.address[0].address}
                                      </span>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          
                          </div>
                        ))}
                    </div>
                  ) : (
                    // Vista en Tabla
                    <div className="table-responsive">
                      <Table hover className={styles.elegantTable}>
                        <thead>
                          <tr>
                            <th width="50px"></th>
                            <th>Nombre</th>
                            <th>Cuenta Contrato</th>
                            <th>Cuenta Enel</th>
                            <th>Suscriptor</th>
                            <th>Dirección</th>
                            <th>Ciudad</th>
                            <th width="120px">Acciones</th>
                          </tr>
                        </thead>
                        <tbody>
                          {tableData.map((contact, idx) => (
                            <tr key={idx} className={styles.tableRow}>
                              <td>
                                <div className={styles.tableAvatar}>
                                  {contact.image ? (
                                    <img src={contact.image} alt="" />
                                  ) : contact.contactType && contact.gender === "Masculino" ? (
                                    <img src={avatarHombre} alt="" />
                                  ) : contact.contactType && contact.gender === "Femenino" ? (
                                    <img src={avatarMujer} alt="" />
                                  ) : contact.contactType === "EMPRESA" ? (
                                    <img src={companyAvatar} alt="" />
                                  ) : (
                                    <img src={imgDefault} alt="" />
                                  )}
                                </div>
                              </td>
                              <td>
                                <div className={styles.contactInfo}>
                                  <strong className={styles.contactName}>
                                    {contact.get_full_name}
                                  </strong>
                                  <div className={styles.contactType}>
                                    {contact.contactType || "Contacto"}
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div className={`${styles.dataCell} ${styles.contrato}`}>
                                  <TbId size={14} className={styles.cellIcon} />
                                  {contact.cuenta_contrato_ciudad_limpia || "N/A"}
                                </div>
                              </td>
                              <td>
                                <div className={`${styles.dataCell} ${styles.enel}`}>
                                  <TbPlug size={14} className={styles.cellIcon} />
                                  {contact.cuenta_enel || "N/A"}
                                </div>
                              </td>
                              <td>
                                <div className={`${styles.dataCell} ${styles.suscriptor}`}>
                                  <TbUserCheck size={14} className={styles.cellIcon} />
                                  {contact.suscriptor || "N/A"}
                                </div>
                              </td>
                              <td>
                                <div className={`${styles.dataCell} ${styles.direccion}`}>
                                  <TbMapPin size={14} className={styles.cellIcon} />
                                  <span className={styles.truncateText}>
                                    {contact.direccion}
                                  </span>
                                </div>
                              </td>
                              <td>
                                <div className={`${styles.dataCell} ${styles.ciudad}`}>
                                  <TbBuilding size={14} className={styles.cellIcon} />
                                  {contact.ciudad}
                                </div>
                              </td>
                              <td>
                                <button
                                  className={styles.viewButton}
                                  onClick={() => handleShow(contact.id)}
                                >
                                  <TbEdit size={16} />
                                  Editar
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  )}
                </CardBody>
              ) : (
                <CardBody className="text-center py-5">
                  <div className="empty-state">
                    <TbSearch size={48} className="text-muted mb-3" />
                    <h4 className="text-muted">No se encontraron contactos</h4>
                    <p className="text-muted">
                      {search ? "Intenta con otros términos de búsqueda" : "No hay contactos registrados aún"}
                    </p>
                  </div>
                </CardBody>
              )}
              
              {/* Paginación */}
              {params.count > 0 && (
                <div className="mt-4">
                  <Pagination
                    count={params.count}
                    next={params.next}
                    previous={params.previous}
                    limit={30}
                    baseUrl="contact/contacto/"
                    filterFunction={contactsFilter}
                  />
                </div>
              )}
            </div>
          )}
        </Container>

        {/* Mostrar la alerta si existe */}
        {alert && (
          <Alert
            title={alert.title}
            message={alert.message}
            type={alert.type}
            onConfirm={closeAlert}
          />
        )}
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { error, loading, contacts } = state.Contacts;
  return { error, loading, contacts };
};

export default withRouter(connect(mapStateToProps)(ContactsList));